import { render, staticRenderFns } from "./CollectionPage.vue?vue&type=template&id=388cca0e&scoped=true"
import script from "./CollectionPage.vue?vue&type=script&lang=js"
export * from "./CollectionPage.vue?vue&type=script&lang=js"
import style0 from "./CollectionPage.vue?vue&type=style&index=0&id=388cca0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388cca0e",
  null
  
)

export default component.exports